<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="title-complete-journey">
      <h1>Jornada completa</h1>
    </div>
    <hr>
      @if (isLoading) {
        <app-loading-list></app-loading-list>
      }
      @if (!isLoading) {
        <div class="body-complete-journey">
          <h2>Admissão</h2>
          @if (this.patientHistory.episode &&
            (this.patientHistory.episode.waitingTime ||
            this.patientHistory.episode.serviceTime ||
            this.patientHistory.episode.userName)) {
            <div class="module-content">
              <div class="time-content">
                <div class="block-time">
                  <p><b>Tempo de espera:</b></p>
                  <div class="time-count">
                    <span>{{this.patientHistory.episode.waitingTime ? this.patientHistory.episode.waitingTime :
                    '00:00:00'}}</span>
                  </div>
                </div>
                <div class="block-time">
                  <p><b>Tempo de atendimento:</b></p>
                  <div class="time-count">
                    <span>{{this.patientHistory.episode.serviceTime ? this.patientHistory.episode.serviceTime :
                    '00:00:00'}}</span>
                  </div>
                </div>
              </div>
              <p class="professional-responsability"><b>Profissional responsável:
              </b>{{this.patientHistory.episode.userName ? this.patientHistory.episode.userName : ''}}</p>
            </div>
          }
          <hr>
            <h2>Classificação de Risco</h2>
            @if (this.patientHistory.triage.length > 0) {
              <div class="module-content">
                @for (triage of this.patientHistory.triage; track triage) {
                  <div>
                    <div class="time-content">
                      <div class="block-time">
                        <p><b>Tempo de espera:</b></p>
                        <div class="time-count">
                          <span>{{triage.waitingTime ? triage.waitingTime : '00:00:00'}}</span>
                        </div>
                      </div>
                      <div class="block-time">
                        <p><b>Tempo de atendimento:</b></p>
                        <div class="time-count">
                          <span>{{triage.serviceTime ? triage.serviceTime : '00:00:00'}}</span>
                        </div>
                      </div>
                    </div>
                    <p class="professional-responsability"><b>Profissional responsável:
                    </b>{{triage.userClassificationName ? triage.userClassificationName : ''}}</p>
                  </div>
                }
              </div>
            }
            @if (!(this.patientHistory.triage.length > 0)) {
              <div>
                <p>-</p>
              </div>
            }
            <hr>
              <h2>Atendimento Multiprofissional</h2>
              @if (this.patientHistory.multiProfessionalCareHistorie.length > 0) {
                <div class="module-content">
                  @for (multiProfessionalCareHistorie of this.patientHistory.multiProfessionalCareHistorie; track multiProfessionalCareHistorie) {
                    <div>
                      <div class="time-content">
                        <div class="block-time">
                          <p><b>Tempo de espera:</b></p>
                          <div class="time-count">
                            <span>{{multiProfessionalCareHistorie.waitingTime ?
                            multiProfessionalCareHistorie.waitingTime : '00:00:00'}}</span>
                          </div>
                        </div>
                        <div class="block-time">
                          <p><b>Tempo de atendimento:</b></p>
                          <div class="time-count">
                            <span>{{multiProfessionalCareHistorie.serviceTime ?
                            multiProfessionalCareHistorie.serviceTime : '00:00:00'}}</span>
                          </div>
                        </div>
                      </div>
                      <p class="professional-responsability"><b>Profissional responsável:
                      </b>{{multiProfessionalCareHistorie.multiProfessionalCare.userName ?
                    multiProfessionalCareHistorie.multiProfessionalCare.userName : ''}}</p>
                  </div>
                }
              </div>
            }
            @if (!(this.patientHistory.multiProfessionalCareHistorie.length > 0)) {
              <div>
                <p>-</p>
              </div>
            }
            <hr>
              <h2>Atendimento Médico</h2>
              @if (this.patientHistory.medicalCareHistorie.length > 0) {
                <div class="module-content">
                  @for (medicalCareHistorie of this.patientHistory.medicalCareHistorie; track medicalCareHistorie) {
                    <div>
                      <div class="time-content">
                        <div class="block-time">
                          <p><b>Tempo de espera:</b></p>
                          <div class="time-count">
                            <span>{{medicalCareHistorie.medicalCare.waitingTime ?
                            medicalCareHistorie.medicalCare.waitingTime : '00:00:00'}}</span>
                          </div>
                        </div>
                        <div class="block-time">
                          <p><b>Tempo de atendimento:</b></p>
                          <div class="time-count">
                            <span>{{medicalCareHistorie.medicalCare.serviceTime ?
                            medicalCareHistorie.medicalCare.serviceTime : '00:00:00'}}</span>
                          </div>
                        </div>
                      </div>
                      <p class="professional-responsability"><b>Profissional responsável:
                      </b>{{medicalCareHistorie.medicalCare.userName ? medicalCareHistorie.medicalCare.userName : ''}}
                    </p>
                  </div>
                }
              </div>
            }
            @if (!(this.patientHistory.medicalCareHistorie.length > 0)) {
              <div>
                <p>-</p>
              </div>
            }
            <hr>
              <h2>Observação</h2>
              @if (this.patientHistory.listServiceObservationStruct.length > 0) {
                <div class="module-content">
                  @for (serviceObservationStruct of this.patientHistory.listServiceObservationStruct; track serviceObservationStruct) {
                    <div>
                      <div class="time-content">
                        <div class="block-time">
                          <p><b>Tempo de espera:</b></p>
                          <div class="time-count">
                            <span>{{serviceObservationStruct.waitingTime ? serviceObservationStruct.waitingTime :
                            '00:00:00'}}</span>
                          </div>
                        </div>
                        <div class="block-time">
                          <p><b>Tempo de atendimento:</b></p>
                          <div class="time-count">
                            <span>{{serviceObservationStruct.serviceTime ? serviceObservationStruct.serviceTime :
                            '00:00:00'}}</span>
                          </div>
                        </div>
                      </div>
                      <p class="professional-responsability"><b>Profissional responsável:
                      </b>{{serviceObservationStruct.userName ? serviceObservationStruct.userName : ''}}</p>
                      @if (serviceObservationStruct.medicalProcedures.length > 0 || serviceObservationStruct.medicalPrescription.length > 0) {
                        <p class="footer-block"
                          >
                          <b>Procedimentos realizados: </b>
                        </p>
                      }
                      @if (serviceObservationStruct.medicalProcedures.length > 0 || serviceObservationStruct.medicalPrescription.length > 0) {
                        <div class="procedures-content"
                          >
                          @for (medicalProcedure of serviceObservationStruct.medicalProcedures; track medicalProcedure) {
                            <div>
                              @if (medicalProcedure.procedureName) {
                                <p class="footer-block">
                                {{medicalProcedure.procedureName}}</p>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (serviceObservationStruct.medicalPrescription.length > 0) {
                        <div class="procedures-content">
                          @for (medicalPrescription of serviceObservationStruct.medicalPrescription; track medicalPrescription) {
                            <div>
                              @if (medicalPrescription.medicineName) {
                                <p class="footer-block">
                                {{medicalPrescription.medicineName}}</p>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (!(this.patientHistory.listServiceObservationStruct.length > 0)) {
                <div>
                  <p>-</p>
                </div>
              }
              <hr>
                <h2>SADT</h2>
                @for (medicalCareHistorieSadt of this.patientHistory.listMedicalCareSadt; track medicalCareHistorieSadt) {
                  <div class="module-content">
                    @if (medicalCareHistorieSadt &&
                      (medicalCareHistorieSadt.waitingTime ||
                      medicalCareHistorieSadt.serviceTime ||
                      medicalCareHistorieSadt.userName)) {
                      <div>
                        <div class="time-content">
                          <div class="block-time">
                            <p><b>Tempo de espera:</b></p>
                            <div class="time-count">
                              <span>{{medicalCareHistorieSadt.waitingTime ?
                                medicalCareHistorieSadt.waitingTime :
                              '00:00:00'}}</span>
                            </div>
                          </div>
                          <div class="block-time">
                            <p><b>Tempo de atendimento:</b></p>
                            <div class="time-count">
                              <span>{{medicalCareHistorieSadt.serviceTime ?
                                medicalCareHistorieSadt.serviceTime :
                              '00:00:00'}}</span>
                            </div>
                          </div>
                        </div>
                        <p class="professional-responsability"><b>Profissional responsável:
                        </b>{{medicalCareHistorieSadt.userName ?
                      medicalCareHistorieSadt.userName : ''}}</p>
                      @if (medicalCareHistorieSadt.medicalCareSadt.length > 0) {
                        <p class="footer-block"><b>Exames
                        realizados: </b></p>
                      }
                      @if (medicalCareHistorieSadt.medicalCareSadt.length > 0) {
                        <div class="procedures-content">
                          @for (medicalCareSadt of medicalCareHistorieSadt.medicalCareSadt; track medicalCareSadt) {
                            <div>
                              @for (item of medicalCareSadt.medicalCareSadt; track item) {
                                <div>
                                  @if (item.sadtName) {
                                    <p class="footer-block">{{item.sadtName}}</p>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (!(this.patientHistory.medicalCareHistorie.length > 0)) {
                    <div>
                      <p>-</p>
                    </div>
                  }
                </div>
              }
              <hr>
                <h2>Tempo total da Unidade</h2>
                @if (this.patientHistory.startTimeSoFar != null) {
                  <div class="module-content">
                    <div class="block-time">
                      <div class="time-count">
                        <span>{{this.patientHistory.startTimeSoFar ? this.patientHistory.startTimeSoFar :
                        '00:00:00'}}</span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            <div class="btn-container">
              <button mat-flat-button color="accent" class="button-close-complete-journey"
              (click)="close()">FECHAR</button>
            </div>
          </div>
        </div>